import styled from 'styled-components';
import { darken, lighten } from 'polished';

interface Props {
  color?: string;
  backgroundColor?: string;
  secondary?: boolean;
}

const Button = styled.button<Props>`
  align-items: center;
  background-color: ${({ backgroundColor, secondary }) =>
    secondary ? 'transparent' : backgroundColor || '#5468FF'};
  border-radius: 4px;
  border: ${({ secondary, backgroundColor }) =>
    secondary ? `1px solid ${backgroundColor || '#5468FF'}` : 0};
  color: ${({ color, secondary, backgroundColor }) =>
    secondary ? backgroundColor || '#5468FF' : color || '#FFF'};
  cursor: pointer;
  display: flex;
  font-family: 'Inter UI';
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  justify-content: center;
  line-height: 24px;
  outline: none;
  padding: 8px;
  position: relative;
  text-align: center;
  width: 100%;

  &:hover {
    background-color: ${({ backgroundColor, secondary }) =>
      secondary
        ? backgroundColor || '#5468FF'
        : darken(0.02, backgroundColor || '#5468FF')};
    ${({ secondary }) => secondary && 'color: #FFF'};
  }
  &:active {
    background-color: ${({ backgroundColor }) =>
      darken(0.1, backgroundColor || '#5468FF')};
  }
  &:disabled {
    cursor: default;
    background-color: ${({ backgroundColor }) =>
      backgroundColor ? lighten(0.085, backgroundColor) : '#DFE1F0'};
  }

  .button-icon {
    display: flex;
    position: absolute;
    right: 14px;
  }
`;

export default Button;
